export function extractDirtyProperties(mainObject: object, dirtyKeys: object) {
  const extract = (mainObj, dirtyObj) => {
    const result = Array.isArray(dirtyObj) ? [] : {};

    if (mainObj && typeof mainObj === "object" && "id" in mainObj) {
      result["id"] = mainObj["id"];
    }

    for (const key in dirtyObj) {
      if (Array.isArray(dirtyObj[key])) {
        // For arrays, iterate through each item
        result[key] = dirtyObj[key].map((item, index) => {
          return extract(mainObj?.[key]?.[index], item);
        });
      } else if (typeof dirtyObj[key] === "object") {
        // For objects, recurse
        result[key] = extract(mainObj[key], dirtyObj[key]);
      } else if (dirtyObj[key] === true) {
        // If the property is marked as dirty, add it to the result
        if (mainObj) {
          result[key] = mainObj[key];
        }
      }
    }
    return result;
  };

  return extract(mainObject, dirtyKeys);
}

type ErrorObject = {
  [key: string]: any;
};

export function flattenErrors(
  errors: ErrorObject,
  prefix: string = ""
): ErrorObject {
  let flatErrors: ErrorObject = {};

  for (let key in errors) {
    if (errors.hasOwnProperty(key)) {
      const value = errors[key];
      const newKey = prefix ? `${prefix}.${key}` : key;

      if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value)
      ) {
        // Recursively flatten nested objects
        flatErrors = { ...flatErrors, ...flattenErrors(value, newKey) };
      } else if (Array.isArray(value)) {
        // Flatten array items
        value.forEach((item, index) => {
          if (typeof item === "object" && item !== null) {
            flatErrors = {
              ...flatErrors,
              ...flattenErrors(item, `${newKey}.${index}`),
            };
          } else {
            flatErrors[`${newKey}.${index}`] = item;
          }
        });
      } else {
        flatErrors[newKey] = value;
      }
    }
  }

  // Transform the flat errors to the desired format
  let transformedErrors: ErrorObject = {};
  for (let key in flatErrors) {
    if (flatErrors.hasOwnProperty(key)) {
      if (key.endsWith(".message")) {
        const newKey = key.replace(".message", "");
        transformedErrors[newKey] = { message: flatErrors[key] };
      } else if (!key.includes(".message")) {
        const parentKey = key.split(".").slice(0, -1).join(".");
        if (flatErrors[parentKey] && flatErrors[parentKey].message) {
          transformedErrors[parentKey] = {
            ...transformedErrors[parentKey],
            [key.split(".").pop()!]: flatErrors[key],
          };
        } else {
          transformedErrors[key] = flatErrors[key];
        }
      }
    }
  }

  return transformedErrors;
}
